import React from 'react';
import Modal from '../../../../../../components/Modals/Modal';
import styles from '../../../../../../styles/modals.module.scss';
import ButtonCustom from '../../../../../../components/Buttons/Button';
import { Box } from '@material-ui/core';
import SDialog from '../../../../../../components/SDialog/SDialog';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import Typography from '../../../../../../components/Typography/Typography';

const ViewNetworks = ({ site, showNetworksView, onClose, togglePopup }) => {
  return (
    <SDialog
      title='View Networks'
      open={showNetworksView}
      onClose={onClose}
      secondaryButtonConfig={{
        text: 'Close',
        onClick: onClose
      }}
    >
      <FlexColumn>
        <FlexRow flexWrap='nowrap' justifyContent='space-between' alignItems='start'>
          <FlexColumn alignItems='start' gap='0.2rem' width='fit-content' styles={{ minWidth: '10rem' }}>
            <Typography variant={"b1SB"} color='var(--brand-500)'>Site Name</Typography>
            <Typography variant={"b2M"}>{site?.name}</Typography>
          </FlexColumn>
          <FlexColumn alignItems='start' justifyContent='start' gap='0.2rem' width='fit-content' styles={{ minWidth: '10rem' }}>
            <Typography variant={"b1SB"} color='var(--brand-500)'>Site Location</Typography>
            <Typography variant={"b2M"}>{site?.location}</Typography>
          </FlexColumn>
        </FlexRow>
        <FlexColumn>
          {site?.networks?.map((item) => (
            <Typography
              style={{
                border: '1px solid #D3D3D3',
                borderRadius: '15px',
                padding: 10,
                fontSize: 15,
                width: '100%'
              }}
            >
              {item?.name}
            </Typography>
          ))}
        </FlexColumn>
      </FlexColumn>
    </SDialog>
  );
};

export default ViewNetworks;
